// Spatial layers source names
export const SOURCE_911INFORM = '911inform';
export const SOURCE_CRG = 'crg';
export const SOURCE_GEOCOMM = 'geocomm';

export const GEOCOMM_ICON_MIN_ZOOM = 13;
